import { FCX } from "@datassential/platform-ui-lib";
import { IoFastFoodOutline } from "react-icons/io5";
import { ICategoryProfileDetails } from "@apiHooks/useCategoryProfileDetails";
import ProfileSidebar from "@components/ProfileSidebar/ProfileSidebar";
import CategoryProfileExport from "./components/CategoryProfileExport/CategoryProfileExport";
import RelatedProfiles from "./components/RelatedProfiles/RelatedProfiles";
import RelatedCharts from "./components/RelatedCharts/RelatedCharts";
import "./CategoryProfileSidebar.styles.scss";

interface Props {
    data?: ICategoryProfileDetails | null;
    categoryName: string;
    isCollapsed: boolean;
    isScrolled?: boolean;
}

const CategoryProfileSidebar: FCX<Props> = ({ data, categoryName, isCollapsed, isScrolled = false }) => {
    const { imageUrl, categoryOverviews = [], relatedProfiles = [], relatedCharts = [] } = data ?? {};
    const hasRelatedContent = relatedProfiles.length > 0 || relatedCharts.length > 0;

    return (
        <ProfileSidebar
            className="CategoryProfileSidebar"
            testId="blockCategoryProfileSidebar"
            imageTestId="imgCategoryProfileSidebar"
            image={{ src: imageUrl ?? "", alt: categoryName, placeholder: <IoFastFoodOutline/> }}
            actions={(
                <CategoryProfileExport
                    categoryName={categoryName}
                    reports={categoryOverviews}
                    isCollapsed={isCollapsed}
                />
            )}
            isCollapsed={isCollapsed}
            isScrolled={isScrolled}
        >
            {hasRelatedContent && (<>
                <RelatedProfiles profiles={relatedProfiles} />
                {relatedProfiles.length > 0 && relatedCharts.length > 0 && (
                    <div className="CategoryProfileSidebar__divider" />
                )}
                <RelatedCharts charts={relatedCharts} />
            </>)}
        </ProfileSidebar>
    );
};

export default CategoryProfileSidebar;
